<template>
  <div class="flex items-center p-6 justify-between">
    <div class="flex items-center space-x-4  rtl:space-x-reverse">
      <div v-if="showBack" class="text-secondary">
        <a @click="back">
          <b-icon icon="chevronLeft" class="h-10 w-10 cursor-pointer" />
        </a>
      </div>
      <div class="text-secondary text-3xl font-semibold">
        {{ title }}
      </div>
    </div>

    <div class="text-secondary">
      <a @click="close">
        <b-icon icon="x" class="h-10 w-10 cursor-pointer" />
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  title: string
  backRoute: string
  showBack: boolean
}

const props = withDefaults(defineProps<Props>(), {
  title: '',
  backRoute: '',
  showBack: false
})

const { $site } = useNuxtApp()

const back = () => {
  navigateTo(props.backRoute)
}

const close = () => {
  $site.events.$emit('_bookapp.bot.close')
}
</script>
